import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Types ───

export interface InventoryItemRow {
  id: string;
  org_id: string | null;
  item_type: string | null;
  // PRD.260 — package validity period in months; null for non-packages.
  validity_months: number | null;
  item_name: string | null;
  sku: string | null;
  external_id: string | null;
  category: string | null;
  tags: string | null;
  local_name: string | null;
  description: string | null;
  remarks: string | null;
  status: string | null;
  image_url: string | null;
  selling_price: number | null;
  minimum_selling_price: number | null;
  cost_price: number | null;
  tax_inclusive: number | null; // 0/1
  open_pricing: number | null; // 0/1
  purchasing_unit: string | null;
  inventory_unit: string | null;
  pack_size_quantity: number | null;
  track_stock: number | null; // 0/1
  initial_stock_quantity: number | null;
  low_stock_limit: number | null;
  minimum_order_quantity: number | null;
  inactive: number | null; // 0/1
  // PRD.234 — Pharmacy-dispensable Product capability (Products only).
  dispense_via_pharmacy: number | null; // 0/1
  // PRD.264 — Supply behavior fields.
  supply_usage_type: string | null; // 'consumable' | 'expendable' (supplies only)
  is_sellable: number | null; // 0/1
  batch_tracked: number | null; // 0/1
  consignment: number | null; // 0/1
  manufacturing_barcode: string | null;
  accounting_code: string | null;
  external_reference_code: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface InventoryMedicineDetailRow {
  id: string;
  inventory_item_id: string | null;
  drug_classification: string | null;
  brand_name: string | null;
  generic_name: string | null;
  manufacturer: string | null;
  indication: string | null;
  strength: string | null;
  dosage_form: string | null;
  route: string | null;
  precaution_1: string | null;
  precaution_2: string | null;
  default_instruction: string | null;
  default_dosage: string | null;
  usage: string | null;
  dose: string | null;
  dose_unit: string | null;
  frequency: string | null;
  duration: string | null;
  created_at: string | null;
  updated_at: string | null;
}

// ─── Queries ───

export function qInventoryItemsList(): QuerySpec<[]> {
  return {
    key: ['inventory-items'] as const,
    sql: `SELECT * FROM inventory_items ORDER BY item_name ASC`,
    params: [],
    watch: ['inventory_items'],
  };
}

export function qInventoryItemById(itemId: string): QuerySpec<[string]> {
  return {
    key: ['inventory-item', itemId] as const,
    sql: `SELECT * FROM inventory_items WHERE id = ? LIMIT 1`,
    params: [itemId],
    watch: ['inventory_items'],
  };
}

export function qInventoryMedicineDetailsByItem(itemId: string): QuerySpec<[string]> {
  return {
    key: ['inventory-medicine-details', itemId] as const,
    sql: `SELECT * FROM inventory_medicine_details WHERE inventory_item_id = ? LIMIT 1`,
    params: [itemId],
    watch: ['inventory_medicine_details'],
  };
}
